// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"88e74da2","626":"17cc3e16"}[chunkId] + ".chunk.css";
};